angular.module('dpw.components')
/**
 * @ngdoc component
 * @name dpwListGroup
 * @restrict E
 * @description
 * Display a list group.
 * @param {string} [header] - Group title.
 * @param {string} [extraClass] - Group's extra class name.
 * @param {string} [highlight="normal"] - Highlight style for active item. Built-in value: normal | fill.
 * @param {array} items - Group items. Item's options could be:
 *      [item.icon]  - Icon of the item.
 *      item.label - Label of the item.
 *      [item.href] - Link item, item would be wrapped in the `a` tag.
 *      [item.action] - Action when clicking item.
 *      [item.active] - (De)Activated item.
 *      [item.extraClass] - Extra class for the item.
 *      [item.iconTail] - Icon displayed on the tail of the item.
 * @example
 * <dpw-list-group title="Getting Started" items="$ctrl.listGroupItems"></dpw-list-group>
 */
    .component('dpwListGroup', {
        templateUrl: 'dpw-list-group.html',
        bindings: {
            header: '<',
            items: '=',
            highlight: '<',
            extraClass: '<'
        },
        controller: [function() {
            var vm = this;
            vm.highlight = vm.highlight || 'normal';
            vm.extraClass = vm.extraClass || '';
        }]
    });